import { TopLogoPanel } from "components";
import { LoginComponent } from "./LoginComponent";
import Layout from "layouts";

export const Login = () => {
  return (
    <Layout variant="empty">
      <TopLogoPanel>
        <LoginComponent />
      </TopLogoPanel>
    </Layout>
  );
};
